import type { PropsWithChildren } from 'react'
import type { StyledComponent } from '@emotion/styled'

import { styledWithTheme } from '@amzn/stencil-react-components/context'
import { H3, H4 } from '@amzn/stencil-react-components/text'

export const ClickableH3: StyledComponent<PropsWithChildren<{ onClick?: () => void }>> =
    styledWithTheme(H3)(({ theme }) => ({
        cursor: 'pointer',
        color: theme.selectors.color('neutral90'),
        ':hover': {
            color: theme.selectors.color('primary80'),
        },
    }))

export const ClickableH4: StyledComponent<PropsWithChildren<{ onClick?: () => void }>> =
    styledWithTheme(H4)(({ theme }) => ({
        cursor: 'pointer',
        color: theme.selectors.color('neutral90'),
        ':hover': {
            color: theme.selectors.color('primary80'),
        },
    }))
